<template>
  <registration-request-layout 
      :requestId="requestId"
      :onRequestProcessed="onRequestProcessed"
      :getRegistrationRequestById="workflowService.getLeaseRegistrationById"
      :setRegistrationData="(registration) => this.registration = registration"
      :signSignatureByAdminFn="workflowService.signLeaseSignatureByAdmin"
      :markPaidByAdminFn="workflowService.markLeasePaidByAdmin"
  >
    <router-link v-if="registration && registration.leaseId" :to="`/admin/leases/${registration.leaseId}`">
      Lease #{{registration.leaseId}}
    </router-link>
    <lease-request :registration="registration">                    
    </lease-request>
  </registration-request-layout>
</template>

<script lang="ts">
import Vue from 'vue';
import LeaseRequest from "@/components/Portal/MyRequest/LeaseRequest.vue";
import RegistrationRequestLayout from "@/components/common/RegistrationRequestLayout.vue";
import workflowService from "@/services/admin/workflowService";

export default Vue.extend({
  name: 'LeaseRequestCard',
  props: {
    requestId: { type: Number },
  },
  components: {
    LeaseRequest,
    RegistrationRequestLayout
  },
  data: function() {
      return {
          registration: {
              workflowGuid: "",
              requestId: 0
          } as any,
      };
  },
  computed: {
    workflowService() {
      return workflowService;
    },
  },
  methods: {
    onRequestProcessed: function (requestId: number) {
      this.$navigate({ path: `/admin/registration/leases` });
    },
  }
});
</script>
